import React, { Component } from 'react';
import RFIDInstance, { WRITE_CPU1_PAGE, WRITE_CPU2_PAGE } from '../../../native-interact/RFID';
import Button from '../../../components/button/Button';
import { parseHexToStr } from '../../../js/utils';

export default class ClearPart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showBtn: true,
      parts: []
    };
  }

  startClear() {
    this.setState({
      showBtn: false
    });

    const allPages = [...WRITE_CPU1_PAGE, ...WRITE_CPU2_PAGE];
    const tasks = allPages.map((item) => {
      return function () {
        let count = 0;
        return new Promise((resolve, reject) => {
          (function executeCommand() {
            count++;
            if (count > 3) {
              return reject(new Error('执行超时'));
            }

            return RFIDInstance.forceWrite('clear', item, '\0\0\0\0\0\0\0\0')
              .then(() => {
                setTimeout(() => {
                  resolve();
                }, 100);
              })
              .catch(() => {
                executeCommand();
              });
          }());
        });
      };
    });

    tasks.reduce(
      (previousPromise, nextPromise, index) => {
        return previousPromise
          .then(() => {
            if (index > 0) {
              this.setState((prevState) => {
                return {
                  parts: prevState.parts.concat(
                    [<p>{allPages[index - 1]}: 已清空</p>]
                  )
                };
              });
            }
            return nextPromise();
          })
          .catch(() => {
            this.setState((prevState) => {
              return {
                parts: prevState.parts.concat(
                  [<p>{allPages[index]}: 清空失败</p>]
                )
              };
            });
            return Promise.resolve();
          });
      },
      Promise.resolve()
    ).then(() => {
      this.setState((prevState) => {
        return {
          showBtn: true,
          parts: prevState.parts.concat(
            [<p>{allPages[allPages.length - 1]}: 已清空</p>]
          )
        };
      });
    });
  }

  render() {
    return (
      <div>
        <h4 className="popup-title">清空命令区</h4>
        {this.state.parts}
        <div style={{ textAlign: 'center' }}>
          <Button
            style={{ display: this.state.showBtn ? 'inline-block' : 'none' }}
            onClick={() => this.startClear()}
          >
            点击开始清空
          </Button>
        </div>
      </div>
    );
  }
}
